@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row && $.adata.fetch_key) {
    @if (isvalidDate($.row[$.adata.fetch_key])) {
    <span [pTooltip]="showDate($.row[$.adata.fetch_key])"
        >{{
          $.row[$.adata.fetch_key] | DayAgo : (hasValue($.adata.applytimezone) ? $.adata.applytimezone : true)
        }}
      </span>
    } @else {
      <span>-</span>
    }
  }
}
